import { ProgressSpinnerDesignTokens } from "@primeuix/themes/types/progressspinner";
import { primitiveColorTokens } from "src/assets/layout/styles/tokens/primitive";

export const progressSpinner: ProgressSpinnerDesignTokens = {
    colorScheme: {
        light: {
            root: {
                colorOne: primitiveColorTokens.blue[450],
                colorTwo: primitiveColorTokens.blue[450],
                colorThree: primitiveColorTokens.blue[450],
                colorFour: primitiveColorTokens.blue[450],
            },
        },
    },
};
